var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema";
const getNotificationsPreferences = fetcher.path("/api/notifications/preferences").method("get").create();
export function getNotificationsPreferencesFromServer() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getNotificationsPreferences({});
        return data;
    });
}
const updateNotificationsPreferences = fetcher.path("/api/notifications/preferences").method("put").create();
export function updateNotificationsPreferencesOnServer(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield updateNotificationsPreferences(request);
        return data;
    });
}
